import { jsx } from "react/jsx-runtime";
import { O as ObjectProperties } from "../../../index-5e4e4f4b.js";
import { useCallback } from "react";
import { B as Button } from "../../../Button-9f0631d3.js";
import { COMMON_CLASSNAME } from "../../constants.js";
import { useInsights } from "../../../hooks/useInsights/useInsights.js";
import { useInsightsImpression } from "../../../hooks/useInsights/useInsightsImpression.js";
import { analyticsEventForImpression, analyticsEventForClick } from "../../../hooks/useInsights/utils.js";
import { invokeFnAsync } from "../../../utils/invokeFn.js";
import "../../../axios-5f69b112.js";
import "../../../_commonjsHelpers-0c53d963.js";
import "../../../utils-f8d1c624.js";
import "../../../index-e71f83b5.js";
import "../../../utils/noOp.js";
import "../../../hooks/useLogger/constants.js";
import "../../../hooks/useLogger/useLogger.js";
import "../../../hooks/useLogger/LoggerContext.js";
import "../../../hooks/useLogger/types.js";
import "../../../hooks/useInsights/InsightsContext.js";
import "../../../index-2d889c01.js";
function FlashButtonGeneric(props) {
  const {
    children,
    id,
    type = "button",
    onClick,
    btnRef,
    color = "primary",
    disabled,
    isBlock,
    className,
    onMouseDown,
    analytics = {}
  } = props, { trackAnalyticsEvent } = useInsights(), analyticsBase = ObjectProperties.BUTTON, impressionData = analyticsEventForImpression(analytics, analyticsBase), { impressionRef } = useInsightsImpression(impressionData, analytics.impressionOptions), multiRef = useCallback(
    (node) => {
      impressionRef(node), typeof btnRef == "function" ? btnRef(node) : btnRef && (btnRef.current = node);
    },
    [btnRef, impressionRef]
  );
  async function handleClick(event) {
    const clickData = analyticsEventForClick(analytics, analyticsBase);
    clickData && trackAnalyticsEvent(clickData), await invokeFnAsync(onClick, [event]);
  }
  return /* @__PURE__ */ jsx("span", { className: COMMON_CLASSNAME, children: /* @__PURE__ */ jsx(
    Button,
    {
      id,
      "data-testid": id,
      type,
      onClick: handleClick,
      onMouseDown,
      innerRef: multiRef,
      color,
      disabled,
      className,
      block: isBlock,
      children
    }
  ) });
}
export {
  FlashButtonGeneric as default
};
//# sourceMappingURL=FlashButtonGeneric.js.map
